import { render, staticRenderFns } from "./CommissionerSection.vue?vue&type=template&id=f86d26e4&"
import script from "./CommissionerSection.vue?vue&type=script&lang=js&"
export * from "./CommissionerSection.vue?vue&type=script&lang=js&"
import style0 from "./CommissionerSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports